import React, { useState, useRef, useEffect } from 'react';
import '../styles/SelezioneRicerca.css';

/**
 * SelezioneRicerca
 * Campo a tendina con ricerca su un elenco di valori codificati.
 * Impedisce il testo libero: il valore salvato è sempre uno di quelli
 * previsti, così non nascono varianti dello stesso termine.
 *
 * Props:
 *  - valore        stringa selezionata
 *  - onChange(v)   riceve la stringa scelta, o '' se azzerata
 *  - opzioni       array di stringhe
 *  - placeholder
 *  - disabilitato
 */

const SelezioneRicerca = ({ valore, onChange, opzioni = [], placeholder, disabilitato }) => {
    const [aperto, setAperto] = useState(false);
    const [filtro, setFiltro] = useState('');
    const [evidenziato, setEvidenziato] = useState(0);
    const contenitore = useRef(null);

    useEffect(() => {
        const fuori = (e) => {
            if (contenitore.current && !contenitore.current.contains(e.target)) {
                setAperto(false);
                setFiltro('');
            }
        };
        document.addEventListener('mousedown', fuori);
        return () => document.removeEventListener('mousedown', fuori);
    }, []);

    const filtrate = opzioni.filter((o) =>
        !filtro.trim() || o.toLowerCase().includes(filtro.toLowerCase())
    );

    const scegli = (v) => {
        onChange(v);
        setAperto(false);
        setFiltro('');
    };

    const daTastiera = (e) => {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setAperto(true);
            setEvidenziato((i) => Math.min(i + 1, filtrate.length - 1));
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setEvidenziato((i) => Math.max(i - 1, 0));
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (aperto && filtrate[evidenziato]) scegli(filtrate[evidenziato]);
        } else if (e.key === 'Escape') {
            setAperto(false);
            setFiltro('');
        }
    };

    return (
        <div className={`sr-contenitore ${disabilitato ? 'disabilitato' : ''}`} ref={contenitore}>
            <div className="sr-campo">
                <input
                    type="text"
                    className="sr-input"
                    value={aperto ? filtro : (valore || '')}
                    placeholder={placeholder || 'Seleziona…'}
                    disabled={disabilitato}
                    onFocus={() => { setAperto(true); setFiltro(''); setEvidenziato(0); }}
                    onChange={(e) => { setFiltro(e.target.value); setAperto(true); setEvidenziato(0); }}
                    onKeyDown={daTastiera}
                    autoComplete="off"
                />
                {valore && !disabilitato && (
                    <button type="button" className="sr-azzera" title="Azzera"
                        onClick={() => scegli('')}>
                        ✕
                    </button>
                )}
                <span className="sr-freccia">▾</span>
            </div>

            {aperto && (
                <ul className="sr-elenco">
                    {filtrate.length === 0 ? (
                        <li className="sr-vuoto">Nessuna corrispondenza</li>
                    ) : (
                        filtrate.map((o, i) => (
                            <li
                                key={o}
                                className={`sr-voce ${o === valore ? 'scelta' : ''} ${i === evidenziato ? 'evidenziata' : ''}`}
                                onMouseDown={(e) => { e.preventDefault(); scegli(o); }}
                                onMouseEnter={() => setEvidenziato(i)}
                            >
                                {o}
                            </li>
                        ))
                    )}
                </ul>
            )}
        </div>
    );
};

export default SelezioneRicerca;
